export class ConfigDB {
	static data = {
		 settings: {
			 layout_type:  'ltr',
		 sidebar: {
			 type: 'horizontal-wrapper',
		 },
		 sidebar_setting: 'default-sidebar', 
		 },
		 color: {
			 primary_color: '#E50014', 
			 secondary_color: '#211833', 
			 mix_background_layout: 'light-only', 
		 },
		 router_animation: 'fadeIn'
	 }
}
export default ConfigDB;





